export default build =>
    build.mutation({
        query(payload) {
            console.log("payload in delete district",payload)
            return {
                url: '/exam/deleteexamschool',
                method: 'POST',
                body: payload,
               
            };
        },
        invalidatesTags: ['allExamSchools'],
    })
